import type { DefaultValues } from 'react-hook-form';
import type { AddProductSchema } from '../components/AddProductContent';

export const ADD_PRODUCT_DEFAULT_VALUES: DefaultValues<AddProductSchema> = {
  productName: '',
  description: '',
  categoryId: undefined,
  specialityId: undefined,
  hsCodeId: undefined,
  productImages: [],
  // Section 2: Pricing & Trade
  minQty: undefined,
  leadTime: undefined,
  pricingTiers: [],
  // Section 3: Product Specifications
  specs: [],
  itemPerCarton: undefined,
  grossWeight: undefined,
  height: undefined,
  width: undefined,
  length: undefined,
  // Section 4: SKU & Inventory
  productType: 'cart',
  applyVariants: false,
  baseStock: undefined,
  basePrice: undefined,
  material: '',
  storage: '',
  colors: [],
  applyPricingTiers: false,
  hasVariants: false,
  numAttributes: undefined,
  attributeNames: [],
  attributeValues: [],
  variants: [],
  colorAttributeId: undefined,
  // Section 5: Customization & OEM
  customizationTypes: [],
  customLogo: [],
  certificatesDocuments: [],
  acceptSampleOrder: false,
  minSampleQty: undefined,
  samplePrice: undefined,
  // Section 6: Product Hub Location
  locationId: undefined,
};

export const ADD_PRODUCT_FIELD_MAPPING: Record<string, keyof AddProductSchema> = {
  productName: 'productName',
  description: 'description',
  categoryId: 'categoryId',
  specialityId: 'specialityId',
  hsCodeId: 'hsCodeId',
  minQty: 'minQty',
  leadTime: 'leadTime',
  itemPerCarton: 'itemPerCarton',
  grossWeight: 'grossWeight',
  height: 'height',
  width: 'width',
  length: 'length',
  minSampleQty: 'minSampleQty',
  samplePrice: 'samplePrice',
  certificatesDocs: 'certificatesDocuments',
  logoImageId: 'customLogo',
  locationId: 'locationId',
};
